 export const FilterTypesEnum = {
    free: 1,
    values: 2
}
